export default __webpack_public_path__ + "static/media/aquarius.7b58b417.png";